import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  APPOINTMENT_PATH,
  APPOINTMENT_REQUEST_FORM_PATH,
  APPOINTMENT_REQUEST_FORM_SUCCESS_PATH,
  APPOINTMENT_RESCHEDULE_CONFIRM_PATH,
  APPOINTMENT_RESCHEDULE_FAILURE_PATH,
  APPOINTMENT_RESCHEDULE_LINKED_PATH,
  APPOINTMENT_RESCHEDULE_PATH,
  APPOINTMENT_RESCHEDULE_SUCCESS_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import { WogaaTrackingSettings } from '@shared/constants/systemSettingsKey';
import type { RouteConfig } from '@shared/types/common.types';

const DashboardPage = lazy(() => import('./pages/DashboardPage/DashboardPage'));
const RescheduleAvailableSlotSelectionPage = lazy(
  () => import('./pages/RescheduleAvailableSlotSelectionPage/RescheduleAvailableSlotSelectionPage')
);
const RescheduleLinkedPage = lazy(() => import('./pages/RescheduleLinkedPage/RescheduleLinkedPage'));
const RescheduleSuccessPage = lazy(() => import('./pages/RescheduleSuccessPage/RescheduleSuccessPage'));
const RescheduleFailurePage = lazy(() => import('./pages/RescheduleFailurePage/RescheduleFailurePage'));
const RescheduleSlotConfirmationPage = lazy(
  () => import('./pages/RescheduleSlotConfirmationPage/RescheduleSlotConfirmationPage')
);
const RequestFormPage = lazy(() => import('./pages/RequestFormPage/RequestFormPage'));
const SuccessfulFormSubmissionPage = lazy(
  () => import('./pages/SuccessfulFormSubmissionPage/SuccessfulFormSubmissionPage')
);

export const APPOINTMENT_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <DashboardPage />,
    displayTitle: () => 'Appointments',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <RescheduleAvailableSlotSelectionPage />,
    displayTitle: () => 'Reschedule Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_RESCHEDULE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
    wogaa: { role: 'start', settingKey: WogaaTrackingSettings.Reschedule },
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: APPOINTMENT_PATH,
    component: () => <RescheduleLinkedPage />,
    displayTitle: () => 'Reschedule Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_RESCHEDULE_LINKED_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <RescheduleSuccessPage />,
    displayTitle: () => 'Reschedule Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_RESCHEDULE_SUCCESS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
    wogaa: { role: 'complete', settingKey: WogaaTrackingSettings.Reschedule },
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: APPOINTMENT_PATH,
    component: () => <RescheduleFailurePage />,
    displayTitle: () => 'Reschedule Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_RESCHEDULE_FAILURE_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <RescheduleSlotConfirmationPage />,
    displayTitle: () => 'Reschedule Appointment',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_RESCHEDULE_CONFIRM_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <RequestFormPage />,
    displayTitle: () => 'Appointment Request',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_REQUEST_FORM_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
    wogaa: { role: 'start', settingKey: WogaaTrackingSettings.AppointmentRequest },
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: APPOINTMENT_PATH,
    component: () => <SuccessfulFormSubmissionPage />,
    displayTitle: () => 'Appointment Request',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_REQUEST_FORM_SUCCESS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
    wogaa: { role: 'complete', settingKey: WogaaTrackingSettings.AppointmentRequest },
  },
];
